export default "__VITE_ASSET__977fc758__"